// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NewCorePricingReq from "../entity/NewCorePricingReq.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CorePricingRepoConfig from "./CorePricingRepoConfig.bs.js";
import * as PostRequestHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/PostRequestHelper.bs.js";

function fetchPricingCampaigns(geo_region_id, vehicle_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/campaigns/list";
  var payload = PostRequestHelper$Catalyst.getPostRequestPayload({
        hd: {
          name: "geo_region_id",
          value: String(geo_region_id)
        },
        tl: {
          hd: {
            name: "vehicle_id",
            value: String(vehicle_id)
          },
          tl: {
            hd: {
              name: "effective_till_instant",
              value: Timestamp$Catalyst.toFloat(Timestamp$Catalyst.now(undefined)).toString()
            },
            tl: /* [] */0
          }
        }
      });
  return Network$Catalyst.postRequestV2(requestUrl, payload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignListResponseConverter.execute, result);
                        });
            });
}

function makeCampaignActionReqPayload(campaign_id) {
  return PostRequestHelper$Catalyst.getPostRequestPayload({
              hd: {
                name: "campaign_external_id",
                value: campaign_id
              },
              tl: /* [] */0
            });
}

function approveCampaign(campaign_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/campaigns/approve";
  return Network$Catalyst.postRequestV2(requestUrl, makeCampaignActionReqPayload(campaign_id), {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

function deleteCampaign(campaign_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/campaigns/delete";
  return Network$Catalyst.postRequestV2(requestUrl, makeCampaignActionReqPayload(campaign_id), {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

function discardCampaign(campaign_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/campaigns/reject";
  return Network$Catalyst.postRequestV2(requestUrl, makeCampaignActionReqPayload(campaign_id), {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

function createCampaign(campaign_req, country) {
  var payloadString = JSON.stringify(NewCorePricingReq.t_encode(campaign_req));
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/campaigns/create";
  return Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

var CorePricingRepo = {
  fetchPricingCampaigns: fetchPricingCampaigns,
  approveCampaign: approveCampaign,
  deleteCampaign: deleteCampaign,
  discardCampaign: discardCampaign,
  createCampaign: createCampaign
};

export {
  CorePricingRepo ,
  
}
/* Config Not a pure module */
